import React from 'react';
import ContentLoader from 'react-content-loader'

import { getLoaderColors } from '../../utils/theme';

import { ThemeContext } from '../../context/ThemeContext';

const Placeholder = props => {
    const bodyClassName = props.bodyClassName || 'project-body';
    return (
        <ThemeContext.Consumer>
            {
                ({ theme }) => (
                    <div className="project-pane">
                        <div className="project-main">
                            <div className="header">
                                <div className="header-main">
                                    <span className="avatar">
                                        <ContentLoader width="36" height="36" style={{ width: '36px', height: '36px' }} animate={!props.static} backgroundColor={getLoaderColors(theme).primary} foregroundColor={getLoaderColors(theme).secondary}>
                                            <rect x="0" y="0" rx="8" ry="8" width="36" height="36" />
                                        </ContentLoader>
                                    </span>

                                    <div className="header-main-inner">
                                        <div className="header-title">
                                            <ContentLoader width="120" height="34" style={{ width: '120px', height: '34px' }} animate={!props.static} backgroundColor={getLoaderColors(theme).primary} foregroundColor={getLoaderColors(theme).secondary}>
                                                <rect x="0" y="11" rx="6" ry="6" width="120" height="12" />
                                            </ContentLoader>
                                        </div>

                                        <div className="header-meta">
                                            <div className="item">
                                                <ContentLoader width="200" height="18" style={{ width: '200px', height: '18px' }} animate={!props.static} backgroundColor={getLoaderColors(theme).primary} foregroundColor={getLoaderColors(theme).secondary}>
                                                    <rect x="0" y="5" rx="4" ry="4" width="200" height="8" />
                                                </ContentLoader>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={bodyClassName}>
                                {props.children}
                            </div>
                        </div>
                    </div>
                )
            }
        </ThemeContext.Consumer>
    )
}

export default Placeholder;
